import { render, staticRenderFns } from "./GeneralDonation.vue?vue&type=template&id=30e0f268&scoped=true"
import script from "./GeneralDonation.vue?vue&type=script&lang=js"
export * from "./GeneralDonation.vue?vue&type=script&lang=js"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./GeneralDonation.vue?vue&type=style&index=1&id=30e0f268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e0f268",
  null
  
)

export default component.exports